import { AuthSignupPost201Response } from "@sizlcorp/sizl-api-document/dist/models";
import { create } from "zustand";

interface UserStore {
  userInfo: AuthSignupPost201Response;
  adminUser: boolean;
  setAdminUser: (adminUser: boolean) => void;
  setUserInfo: (userInfo: AuthSignupPost201Response) => void;
}

export const useUserStore = create<UserStore>((set) => ({
  userInfo: {} as AuthSignupPost201Response,
  adminUser: false,
  setAdminUser: (adminUser) => set({ adminUser }),
  setUserInfo: (userInfo) => set({ userInfo }),
}));
